import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  CircularProgress,
  Button,
  Stack,
  Paper,
} from "@mui/material";
import api from "../../../services/api";
import EditableOrderItemList from "./EditableOrderItemList";
import EditableFulfillmentInfo from "./EditableFulfillmentInfo";
import EditableCustomerInfo from "./EditableCustomerInfo";
import EditableInternalNotes from "./EditableInternalNotes";
import { useSnackbarAlert } from "../../../hooks/useSnackbarAlert";

const OrderEditPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const snackbar = useSnackbarAlert();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [flavorOptions, setFlavorOptions] = useState([]);

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const res = await api.get(`/orders/${id}`);
        const original = res.data;
        const latestEdit =
          Array.isArray(original.edits) && original.edits.length > 0
            ? original.edits[original.edits.length - 1].orderSnapshot
            : null;

        setOrder(latestEdit ? { ...original, ...latestEdit } : original);
      } catch (err) {
        snackbar.error("Failed to load order");
      } finally {
        setLoading(false);
      }
    };

    fetchOrder();
  }, [id]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [flavorsRes] = await Promise.all([api.get("/flavors")]);
        setFlavorOptions(flavorsRes.data || []);
      } catch (err) {
        console.error("Failed to fetch sizes/flavors", err);
      }
    };

    fetchData();
  }, []);

  const handleSave = async () => {
    setSaving(true);
    console.log(order);
    try {
      await api.put(`/orders/${id}`, order);
      snackbar.success("Order updated successfully");
      navigate("/admin/booking");
    } catch (err) {
      snackbar.error("Failed to update order");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <CircularProgress />;

  return (
    <Box p={2}>
      <Typography variant="subtitle1" mb={2}>
        Edit Order #{order.meta?.orderId}
      </Typography>

      <Stack spacing={3}>
        <Paper variant="outlined">
          <EditableOrderItemList
            order={order}
            setOrder={setOrder}
            flavorOptions={flavorOptions}
          />
        </Paper>

        <Paper variant="outlined">
          <EditableFulfillmentInfo order={order} setOrder={setOrder} />
        </Paper>

        <Paper variant="outlined">
          <EditableCustomerInfo order={order} setOrder={setOrder} />
        </Paper>

        <Paper variant="outlined">
          <EditableInternalNotes order={order} setOrder={setOrder} />
        </Paper>
      </Stack>

      <Box mt={4}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          disabled={saving}>
          {saving ? "Saving..." : "Save Changes"}
        </Button>
      </Box>
    </Box>
  );
};

export default OrderEditPage;
